export const CONFIGURE_URL_REDIRECTION_TEXT = {
    defaultMessage: 'Configure URL Redirection',
    id: 'oe.websiteTab.configureUrlRedirection',
    description: 'Popup title',
};

export const URL_REDIRECTION_ENABLED_TEXT = {
    defaultMessage: 'URL redirection is enabled',
    id: 'oe.websiteTab.urlRedirectionEnabled',
    description: 'Label text',
};

export const URL_REDIRECTION_DISABLED_TEXT = {
    defaultMessage: 'URL redirection is disabled',
    id: 'oe.websiteTab.urlRedirectionDisabled',
    description: 'Label text',
};

export const URL_REDIRECTION_INFO_TEXT = {
    defaultMessage: 'If URL redirection is enabled, all visitors to the Passport site or any of its pages will be redirected to the redirect URL.',
    id: 'oe.websiteTab.urlRedirectionInfo',
    description: 'Info popover text',
};

export const REDIRECTION_URL_TEXT = {
    defaultMessage: 'Redirection URL',
    id: 'oe.websiteTab.redirectionUrl',
    description: 'Label text',
};

export const URL_REDIRECTION_UPDATED_TEXT = {
    defaultMessage: 'URL redirection updated',
    id: 'oe.websiteTab.urlRedirectionUpdated',
    description: 'Success notification text',
};
